/**
 * The theme is a V2-only preference in `useV2Theme` (which persists it to
 * localStorage). The tile names what it switches TO, so `next` is the NEXT
 * theme in the cycle — the only thing the View needs.
 *
 * The cycle is `TOKENS`'s own order (M1b: light -> dark -> circlechess ->
 * light), so a fourth palette joins the rotation without touching this file.
 */
import {useCallback} from 'react';

import {THEME_LABELS, TOKENS, V2ThemeName} from '../../../../theme/tokens';
import {useV2Theme} from '../../../../theme/useV2Theme';

const ORDER = Object.keys(TOKENS) as V2ThemeName[];

/** the theme after `name`, wrapping at the end of the cycle */
export const nextTheme = (name: V2ThemeName): V2ThemeName =>
  ORDER[(ORDER.indexOf(name) + 1) % ORDER.length];

export type ThemeTileModel = {
  /** the theme the tile switches to (the one it labels) */
  next: V2ThemeName;
  /** that theme's display name — the tile's label */
  label: string;
  onPress: () => void;
};

export function useThemeTileModel(): ThemeTileModel {
  const name = useV2Theme(s => s.name);
  const setTheme = useV2Theme(s => s.setTheme);
  const next = nextTheme(name);
  const onPress = useCallback(() => setTheme(next), [next, setTheme]);
  return {next, label: THEME_LABELS[next], onPress};
}
